import { setDoc } from './store';
import type { AlertaItem, Documento } from './types';
import { alertasDosDias } from '../lib/alertasData';
import { parseYmd, today, uid } from '../lib/date';
import { N_ } from '../lib/i18n';

/** Tipos de documento: [nome, ícone, avisos padrão (dias antes de vencer)]. O nome é traduzido ao mostrar. */
export const TIPOS_DOC: [string, string, number[]][] = [
  [N_('RG / Carteira de identidade'), '🪪', [90, 30]],
  [N_('CNH'), '🚗', [60, 30, 7]],
  [N_('Passaporte'), '🛂', [180, 60]],
  [N_('CPF'), '🧾', []],
  [N_('Título de eleitor'), '🗳️', []],
  [N_('Carteira de trabalho'), '💼', []],
  [N_('Carteira profissional (OAB, CRC, CREA...)'), '🎓', [60, 30]],
  [N_('Certidão'), '📜', [15, 3]],
  [N_('Documento do veículo (CRLV)'), '🚙', [30, 7]],
  [N_('Seguro'), '🛡️', [30, 7]],
  [N_('Contrato'), '✍️', [60, 30, 7]],
  [N_('Alvará ou licença'), '🏢', [60, 30, 7]],
  [N_('Certificado digital'), '🔐', [30, 7, 1]],
  [N_('Plano de saúde'), '🏥', [30]],
  [N_('Outro'), '📄', [30, 7]],
];
export const iconeDoc = (tipo: string) => TIPOS_DOC.find(x => x[0] === tipo)?.[1] ?? '📄';
export const avisosPadrao = (tipo: string) => TIPOS_DOC.find(x => x[0] === tipo)?.[2] ?? [30, 7];
/** Opções de aviso (dias antes do vencimento). */
export const OPCOES_AVISO = [180, 90, 60, 30, 15, 7, 3, 1];
/** Alertas do vencimento (texto 10, A4): os escolhidos ou, sem escolha, os dias de avisos às 9h e no dia. */
export const alertasDoDoc = (d: Pick<Documento, 'avisos' | 'alertas'>): AlertaItem[] => d.alertas ?? alertasDosDias(d.avisos);

export const novoDocumento = (tipo = TIPOS_DOC[1][0]): Documento => ({
  id: uid(), tipo, nome: '', titular: '', numero: '', orgao: '', emissao: null, validade: null,
  avisos: avisosPadrao(tipo), arquivos: [], notas: '', createdAt: new Date().toISOString(),
});

/** Dias até vencer (negativo = vencido). null = não vence. */
export function diasParaVencer(d: Pick<Documento, 'validade'>, hoje = today()) {
  if (!d.validade) return null;
  return Math.round((parseYmd(d.validade).getTime() - parseYmd(hoje).getTime()) / 864e5);
}

/** Soma anos a uma data YYYY-MM-DD (29/02 vira 28/02 quando o ano não é bissexto). */
export function somarAnos(data: string, anos: number) {
  const [y, m, d] = data.split('-').map(Number);
  const fim = new Date(y + anos, m - 1, 1);
  const ultimo = new Date(fim.getFullYear(), fim.getMonth() + 1, 0).getDate();
  fim.setDate(Math.min(d, ultimo));
  const p2 = (n: number) => String(n).padStart(2, '0');
  return `${fim.getFullYear()}-${p2(fim.getMonth() + 1)}-${p2(fim.getDate())}`;
}

export function salvarDocumento(doc: Documento) {
  setDoc('documentos', d => ({ items: d.items.some(x => x.id === doc.id) ? d.items.map(x => (x.id === doc.id ? doc : x)) : [doc, ...d.items] }));
}
export const excluirDocumento = (id: string) => setDoc('documentos', d => ({ items: d.items.filter(x => x.id !== id) }));
